export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      categories: 'Categories',
      deals: 'Deals',
      favorites: 'Favorites',
      cart: 'Cart',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      admin: 'Admin',
      myAccount: 'My Account',
      orders: 'Orders',
    },
    // Hero
    hero: {
      title: 'Fresh Groceries',
      titleHighlight: 'Delivered Fast',
      subtitle: 'Premium quality produce at your doorstep. Experience the freshest ingredients with just a few clicks.',
      cta: 'Start Shopping',
      search: 'Search for products...',
    },
    // Categories
    categories: {
      title: 'Shop by Category',
      subtitle: 'Explore our selection',
      viewAll: 'View All',
      products: 'products',
    },
    // Products
    products: {
      featured: 'Featured Products',
      deals: 'Today\'s Deals',
      all: 'All Products',
      addToCart: 'Add to Cart',
      addedToCart: 'Added!',
      viewDetails: 'View Details',
      filters: 'Filters',
      clearFilters: 'Clear All',
      sortBy: 'Sort by',
      price: 'Price',
      brand: 'Brand',
      eco: 'Eco-friendly',
      onSale: 'On Sale',
      outOfStock: 'Out of Stock',
      inStock: 'In Stock',
      unit: 'Unit',
      origin: 'Origin',
      benefits: 'Benefits',
      reviews: 'reviews',
      noProducts: 'No products found',
    },
    // Cart
    cart: {
      title: 'Your Cart',
      empty: 'Your cart is empty',
      emptySubtitle: 'Add some products to get started',
      continueShopping: 'Continue Shopping',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      free: 'Free',
      total: 'Total',
      checkout: 'Checkout',
      remove: 'Remove',
      quantity: 'Qty',
    },
    // Checkout
    checkout: {
      title: 'Checkout',
      address: 'Delivery Address',
      phone: 'Phone Number',
      notes: 'Order Notes (optional)',
      placeOrder: 'Place Order',
      orderPlaced: 'Order Placed!',
      orderSuccess: 'Your order has been placed successfully.',
      orderNumber: 'Order Number',
      thankYou: 'Thank you for shopping with us!',
      backToHome: 'Back to Home',
    },
    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot password?',
      noAccount: 'Don\'t have an account?',
      hasAccount: 'Already have an account?',
      loginBtn: 'Sign In',
      registerBtn: 'Create Account',
      welcome: 'Welcome back',
      createAccount: 'Create your account',
    },
    // Admin
    admin: {
      title: 'Admin Dashboard',
      products: 'Products',
      categories: 'Categories',
      orders: 'Orders',
      addProduct: 'Add Product',
      editProduct: 'Edit Product',
      deleteProduct: 'Delete Product',
      save: 'Save',
      cancel: 'Cancel',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Something went wrong',
      success: 'Success!',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      prev: 'Previous',
      all: 'All',
      off: 'OFF',
    },
    // Footer
    footer: {
      about: 'About Us',
      contact: 'Contact',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      rights: 'All rights reserved',
      tagline: 'Fresh groceries delivered to your door',
    },
  },
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      categories: 'Categorias',
      deals: 'Ofertas',
      favorites: 'Favoritos',
      cart: 'Carrito',
      login: 'Ingresar',
      register: 'Registrarse',
      logout: 'Salir',
      admin: 'Admin',
      myAccount: 'Mi Cuenta',
      orders: 'Pedidos',
    },
    // Hero
    hero: {
      title: 'Viveres Frescos',
      titleHighlight: 'Entrega Rapida',
      subtitle: 'Productos de primera calidad en tu puerta. Experimenta los ingredientes mas frescos con solo unos clics.',
      cta: 'Comenzar a Comprar',
      search: 'Buscar productos...',
    },
    // Categories
    categories: {
      title: 'Comprar por Categoria',
      subtitle: 'Explora nuestra seleccion',
      viewAll: 'Ver Todo',
      products: 'productos',
    },
    // Products
    products: {
      featured: 'Productos Destacados',
      deals: 'Ofertas del Dia',
      all: 'Todos los Productos',
      addToCart: 'Agregar al Carrito',
      addedToCart: 'Agregado!',
      viewDetails: 'Ver Detalles',
      filters: 'Filtros',
      clearFilters: 'Limpiar Todo',
      sortBy: 'Ordenar por',
      price: 'Precio',
      brand: 'Marca',
      eco: 'Ecologico',
      onSale: 'En Oferta',
      outOfStock: 'Agotado',
      inStock: 'Disponible',
      unit: 'Unidad',
      origin: 'Origen',
      benefits: 'Beneficios',
      reviews: 'resenas',
      noProducts: 'No se encontraron productos',
    },
    // Cart
    cart: {
      title: 'Tu Carrito',
      empty: 'Tu carrito esta vacio',
      emptySubtitle: 'Agrega productos para comenzar',
      continueShopping: 'Continuar Comprando',
      subtotal: 'Subtotal',
      shipping: 'Envio',
      free: 'Gratis',
      total: 'Total',
      checkout: 'Finalizar Compra',
      remove: 'Eliminar',
      quantity: 'Cant',
    },
    // Checkout
    checkout: {
      title: 'Finalizar Compra',
      address: 'Direccion de Entrega',
      phone: 'Numero de Telefono',
      notes: 'Notas del Pedido (opcional)',
      placeOrder: 'Realizar Pedido',
      orderPlaced: 'Pedido Realizado!',
      orderSuccess: 'Tu pedido ha sido realizado exitosamente.',
      orderNumber: 'Numero de Pedido',
      thankYou: 'Gracias por comprar con nosotros!',
      backToHome: 'Volver al Inicio',
    },
    // Auth
    auth: {
      login: 'Ingresar',
      register: 'Registrarse',
      email: 'Correo Electronico',
      password: 'Contrasena',
      name: 'Nombre Completo',
      confirmPassword: 'Confirmar Contrasena',
      forgotPassword: 'Olvidaste tu contrasena?',
      noAccount: 'No tienes cuenta?',
      hasAccount: 'Ya tienes cuenta?',
      loginBtn: 'Iniciar Sesion',
      registerBtn: 'Crear Cuenta',
      welcome: 'Bienvenido de vuelta',
      createAccount: 'Crea tu cuenta',
    },
    // Admin
    admin: {
      title: 'Panel de Administracion',
      products: 'Productos',
      categories: 'Categorias',
      orders: 'Pedidos',
      addProduct: 'Agregar Producto',
      editProduct: 'Editar Producto',
      deleteProduct: 'Eliminar Producto',
      save: 'Guardar',
      cancel: 'Cancelar',
    },
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Algo salio mal',
      success: 'Exito!',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Agregar',
      search: 'Buscar',
      close: 'Cerrar',
      back: 'Atras',
      next: 'Siguiente',
      prev: 'Anterior',
      all: 'Todo',
      off: 'DESC',
    },
    // Footer
    footer: {
      about: 'Sobre Nosotros',
      contact: 'Contacto',
      terms: 'Terminos y Condiciones',
      privacy: 'Politica de Privacidad',
      rights: 'Todos los derechos reservados',
      tagline: 'Viveres frescos entregados a tu puerta',
    },
  },
};

export const getNestedTranslation = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};
